import { apiConfig } from 'config';
import { swManagerRequest } from './utils';

export const getProtectedDevices = () => {
  const url = apiConfig.swManagerGetProtectedDevices();
  const options = { method: 'GET' };

  return swManagerRequest(url, options);
};
